import { memo } from 'react';

import { ProfileSection } from '@/pages/Profile/types';
import { SeeAllLink, Typography } from '@/ui';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

import EpisodeOfCareItem from '../EpisodeOfCareItem';
import PersonChartedDiagnoses from '../PersonChartedDiagnoses';

import type { Props } from './types';

const PersonEpisodeOfCare = ({ person }: Props) => {
  const { episode_of_care: episodeOfCare, time_zone: timeZone } = person;
  const phase = episodeOfCare?.current_active_phase;
  const primarySubstance = person.program_qualification?.primary_substance;
  const chartedDiagnosis = person.most_recent_chart_diagnoses;

  if (!episodeOfCare && !primarySubstance && !chartedDiagnosis) return null;

  const phaseTypeName = phase && snakeToTitleCase(phase.phase_type.name);

  return (
    <section className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <Typography variant="label" muted weight="bold">
          Episode of Care
        </Typography>
        <SeeAllLink to={`/people/${person.id}#${ProfileSection.EPISODE_OF_CARE}`} />
      </div>
      <div className="flex flex-col gap-3">
        {episodeOfCare && (
          <EpisodeOfCareItem
            label="Program"
            startAt={episodeOfCare.admitted_at}
            timeZone={timeZone}>
            {episodeOfCare.program.name}
          </EpisodeOfCareItem>
        )}
        {phase && (
          <EpisodeOfCareItem label="Phase" startAt={phase.start_at} timeZone={timeZone}>
            {phase.program ? `${phase.program.name}, ${phaseTypeName}` : phaseTypeName}
          </EpisodeOfCareItem>
        )}
        {primarySubstance && (
          <EpisodeOfCareItem label="Primary concern">{primarySubstance}</EpisodeOfCareItem>
        )}
        {chartedDiagnosis && <PersonChartedDiagnoses chartedDiagnosis={chartedDiagnosis} />}
      </div>
    </section>
  );
};

export default memo(PersonEpisodeOfCare);
